import { FileClient } from "@pufflig/promptbook-storage";
import { removeFileFromStorage } from "./removeFileFromStorage";
import { uploadFileToStorage } from "./uploadFileToStorage";
import { readFileFromStorage } from "./readFileFromStorage";

export const getFileClient = (promptbookId: string) =>
  ({
    loadFile: async (fileId) => {
      return readFileFromStorage(promptbookId, fileId);
    },
    saveFile: async (fileId, blob) => {
      await uploadFileToStorage(promptbookId, fileId, blob);
      return;
    },
    removeFile: async (fileId) => {
      await removeFileFromStorage(promptbookId, [fileId]);
      return;
    },
  }) as FileClient;
